import { render, staticRenderFns } from "./u-btn-text-pill.vue?vue&type=template&id=2842c2ac&scoped=true&"
import script from "./u-btn-text-pill.vue?vue&type=script&lang=js&"
export * from "./u-btn-text-pill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2842c2ac",
  null
  
)

export default component.exports